export const getters = {
  NEED_PURCHASE: function (state, getters) {
    return getters["MISSING"] > 0
  },
  REMAINING: function (state, getters, rootState, rootGetters) {
    const wallet = rootState.user.grooviz
    const post_promo_cost = rootGetters["draft/promo/CART_COST"]

    return wallet - post_promo_cost
  },
  MISSING: function (state, getters, rootState, rootGetters) {
    const wallet = rootState.user.grooviz
    const post_promo_cost = rootGetters["draft/promo/CART_COST"]

    return Math.abs(Math.min(wallet - post_promo_cost, 0))
  },
  ADJUSTED_MISSING: function (state, getters) {
    const missing = getters["MISSING"]

    return Math.max(missing, 10)
  },
}
